import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

const ProtectedRoute = ({ children }) => {

const {isAuthenticated}=useSelector((state)=>state.auth);
    return isAuthenticated? children : <Navigate to="/login" />;
    // return children;
};

export default ProtectedRoute;
